"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ComparisonBuilder {
    constructor() {
        this.comparisons = [];
    }
    add(a, b, order = "asc") {
        this.comparisons.push([a, b, order]);
        return this;
    }
    result() {
        for (const [a, b, order] of this.comparisons) {
            if (typeof a == 'string') {
                var i = a.localeCompare(b);
                if (i != 0)
                    return i * (order == "asc" ? 1 : -1);
                continue;
            }
            if (a < b) {
                return -1 * (order == "asc" ? 1 : -1);
            }
            else if (a > b) {
                return 1 * (order == "asc" ? 1 : -1);
            }
        }
        return 0;
    }
}
exports.default = ComparisonBuilder;
//# sourceMappingURL=ComparisonBuilder.js.map